import * as THREE from 'three'

import { VRMUtils, VRMHumanBoneName, VRMExpressionPresetName } from '@pixiv/three-vrm'
import { bones, blendShapes, leftHandBones, rightHandBones, eyesBones } from '@/plugins/vrm-nums'

export default {
  data () {
    return {
      // Custom texture
      faceSkins: [],
      faceSkinTextures: [
        { name: 'face-gaaan', path: '/custom-texture/face-skin/gaaan.png' },
        { name: 'face-sekimen', path: '/custom-texture/face-skin/sekimen.png' },
        { name: 'face-impatient.png', path: '/custom-texture/face-skin/impatient.png' },
        { name: 'face-bloodshed', path: '/custom-texture/face-skin/bloodshed.png' },
        { name: 'face-hematemesis', path: '/custom-texture/face-skin/hematemesis.png' },
        { name: 'face-return-blood', path: '/custom-texture/face-skin/return-blood.png' },
        { name: 'face-goatee', path: '/custom-texture/face-skin/goatee.png' }
      ],
      eyeIrises: [],
      eyeIrisTextures: [
        { name: 'eye-no', path: '/custom-texture/eye-iris/no-eye.png' },
        { name: 'eye-white', path: '/custom-texture/eye-iris/white.png' },
        { name: 'eye-black', path: '/custom-texture/eye-iris/black.png' },
        { name: 'eye-surprised', path: '/custom-texture/eye-iris/surprised.png' },
        { name: 'eye-little-surprised', path: '/custom-texture/eye-iris/little-surprised.png' },
        { name: 'eye-unconscious', path: '/custom-texture/eye-iris/unconscious.png' },
        { name: 'eye-crazy', path: '/custom-texture/eye-iris/crazy.png' },
        { name: 'eye-guruguru', path: '/custom-texture/eye-iris/guruguru.png' },
        { name: 'eye-heart', path: '/custom-texture/eye-iris/heart.png' }
      ],
      // Hide eyes
      // facebakedsInSkinnedMeshToToggleEyes: [
      //   'Facebaked_1', // 瞳
      //   'Facebaked_2', // 目のキラキラ
      //   // 'Facebaked_3', // 顔の肌
      //   // 'Facebaked_4', // 白目？
      //   'Facebaked_5', // 下まつげ？
      //   'Facebaked_6', // 横まつげ
      //   'Facebaked_7', // まつげ
      //   // 'Facebaked_8', // ?
      //   // 'Facebaked', // ?

      //   'Face(Clone)baked_1', // 瞳
      //   'Face(Clone)baked_2', // 目のキラキラ
      //   // 'Face(Clone)baked_3', // 顔の肌
      //   // 'Face(Clone)baked_4', // 白目？
      //   'Face(Clone)baked_5', // 下まつげ？
      //   'Face(Clone)baked_6', // 横まつげ
      //   'Face(Clone)baked_7', // まつげ
      //   // 'Face(Clone)baked_8', // ?
      //   // 'Face(Clone)baked', // ?
      // ],
      materialNamesToToggleEyes: [
        'EyeIris',
        'EyeHighlight',
        'FaceBrow',
        'FaceEyelash',
        'FaceEyeline'
      ],
      whiteEyeTexture: '/custom-texture/white-eye/hide.png',
      originalWhiteEyesTextures: [],
      // Hair wind
      // hairWinds: []
      // Pose
      defaultPoseTags: [
        // 垂直方向
        '立つ', '座る', 'しゃがむ', '寝る', '飛ぶ',
        '歩く', '走る',
        // 感情
        '困る', '焦る', '照れる', '呆れる',
        // 挨拶
        '挨拶',
        // 手持ち
        'スマホ', '筆記用具',
        // 性別
        '女性', '男性'
        // '食器', 'リモコン', 'バッグ', 'リュック', '剣', '銃'
      ]
    }
  },
  computed: {
    allCustomTextures () {
      const faceSkinTextures = this.faceSkinTextures.map(f => {
        return { ...f, type: 'face-skin' }
      })
      const eyeIrisTextures = this.eyeIrisTextures.map(f => {
        return { ...f, type: 'eye-iris' }
      })
      return [ ...faceSkinTextures, ...eyeIrisTextures ]
    },
    leftHandBones () {
      return leftHandBones
    },
    rightHandBones () {
      return rightHandBones
    },
    initialVrmPose () {
      return bones.concat(leftHandBones).concat(rightHandBones).concat(eyesBones)
        .map(bone => {
          return {
            name: bone.name,
            rotation: { x: 0, y: 0, z: 0 }
          }
        }).map(bone => {
          if (bone.name === 'LeftUpperArm') bone.rotation.z = 1.2
          if (bone.name === 'RightUpperArm') bone.rotation.z = -1.2
          if (bone.name === 'LeftLowerArm') bone.rotation.z = 0.2          
          if (bone.name === 'RightLowerArm') bone.rotation.z = -0.2

          const handGraspValue = 0.3
          const leftHandBonesNames = this.leftHandBones.map(b => b.name)
          if (leftHandBonesNames.includes(bone.name)) {
            const axisForGrasp = this.leftHandBones
              .filter(b => b.name === bone.name)[0].axisForGrasp
            bone.rotation.x = axisForGrasp.x * handGraspValue
            bone.rotation.y = axisForGrasp.y * handGraspValue
            bone.rotation.z = axisForGrasp.z * handGraspValue
          }
          const rightHandBonesNames = this.rightHandBones.map(b => b.name)
          if (rightHandBonesNames.includes(bone.name)) {
            const axisForGrasp = this.rightHandBones
              .filter(b => b.name === bone.name)[0].axisForGrasp
            bone.rotation.x = axisForGrasp.x * handGraspValue
            bone.rotation.y = axisForGrasp.y * handGraspValue
            bone.rotation.z = axisForGrasp.z * handGraspValue
          } 
          return bone
        })
    },
    initialVrmBlendShape () {
      return blendShapes.map(blendShape => {
        return {
          name: blendShape.name,
          value: 0
        }
      })
    },
    // initialVrmBlendShapeV0 () {
    //   return blendShapes.map(blendShape => {
    //     return {
    //       name: blendShape.nameV0,
    //       value: 0
    //     }
    //   })
    // }
  },
  methods: {
    isVRM1 ({ vrm }) {
      return vrm.meta.version && vrm.meta.version.includes('v1')
    },
    removeUnnecessaryElementsFromVRM ({ gltf }) {
      VRMUtils.removeUnnecessaryJoints(gltf.scene)
      VRMUtils.removeUnnecessaryVertices(gltf.scene)
      // gltf.userData.vrm.scene.traverse(node => {
      //   node.frustumCulled = false
      // })
    },
    getNormalizedBoneNodeByName ({ vrm, name }) {
      const humanBoneName = VRMHumanBoneName
      return vrm.humanoid
      .getNormalizedBoneNode(humanBoneName[name])
    },
    getPose ({ vrm }) {
      const humanBoneName = VRMHumanBoneName
      let boneNames = []
      Object.keys(humanBoneName).forEach((k) => {
        if (vrm.humanoid.getNormalizedBoneNode(humanBoneName[k])) {
          boneNames.push(k)
        }
      })
      const pose = boneNames.map(boneName => {
        const boneNode = vrm.humanoid
          .getNormalizedBoneNode(humanBoneName[boneName])
        const rotation = boneNode.rotation
        return {
          name: boneName,
          rotation: {
            x: rotation.x, y: rotation.y, z: rotation.z 
          }
        }
      })

      // const pose = this.initialVrmPose.map(pose => {
      //   const boneNode = vrm.humanoid
      //     .getNormalizedBoneNode(boneNames[pose.name])
      //   // const node = humanoid.getBoneNode(boneNames[pose.name])
      //   const rotation = boneNode.rotation
      //   return { 
      //     name: pose.name,
      //     rotation: {
      //       x: rotation.x, y: rotation.y, z: rotation.z 
      //     }
      //   }
      // })
      return pose
    },
    updatePose ({ vrm, pose, delta }) {
      if (!vrm) return

      const boneNames = VRMHumanBoneName
      for (let i=0; i < pose.length; i++) {
        let boneNode = vrm.humanoid
          .getNormalizedBoneNode(boneNames[pose[i].name])
        if (boneNode && boneNode.rotation) {
          if (this.isVRM1({ vrm })) {
            boneNode.rotation.set(
              -pose[i].rotation.x, -pose[i].rotation.y, -pose[i].rotation.z
            )
          } else {
            boneNode.rotation.set(
              pose[i].rotation.x, pose[i].rotation.y, pose[i].rotation.z
            )
          }
          // boneNode.rotation.set(
          //   pose[i].rotation.x, pose[i].rotation.y, pose[i].rotation.z
          // )
          // if (boneNames[pose[i].name] === 'rightEye') debugger
        }
      }
      vrm.update(delta)
    },
    updateBlendShape ({ vrm, blendShape, delta }) {
      if (!vrm) return
      // const schemaBlendShape = VRMSchema.BlendShapePresetName
      // for (let i=0; i < blendShape.length; i++) {
      //   const currentValue = vrm.blendShapeProxy.getValue(schemaBlendShape[blendShape[i].name])
      //   if (currentValue === blendShape[i].value) continue
      //   vrm.blendShapeProxy.setValue(schemaBlendShape[blendShape[i].name], blendShape[i].value)
      //   // vrm.blendShapeProxy.setValue(VRMSchema.BlendShapePresetName.Joy, 0.1)
      //   // vrm.blendShapeProxy.setValue('Joy', 1.0)
      // }
      
      // オブジェクトループ
      // const vrmBlendShape = vrm.blendShapeProxy.blendShapePresetMap
      // const vrmExpressionName = VRMExpressionPresetName
      // Object.keys(vrmExpressionName).forEach((k) => {
      //   let targetBlendShape = blendShape
      //     .filter(b => b.name === vrmExpressionName[k])[0]
      //   // v0の時の名前だった場合
      //   if (!targetBlendShape) {
      //     targetBlendShape = blendShape
      //       .filter(b => b.nameV0 === vrmExpressionName[k])[0]
      //   }
      //   if (targetBlendShape) {
      //     vrm.expressionManager.setValue(targetBlendShape.name, targetBlendShape.value)
      //     // vrm.blendShapeProxy.setValue(targetBlendShape.name, targetBlendShape.value)
      //   }
      // })

      const vrmExpressionName = VRMExpressionPresetName
      blendShape.map(b => {
        let name = vrmExpressionName[b.name]
        if (!name) {
          const blendShapeV0 = this.initialVrmBlendShape
            .filter(ivb => ivb.nameV0 === b.name)[0]
          if (blendShapeV0) name = blendShapeV0.name
        }
        if (name) vrm.expressionManager.setValue(name, b.value)
      })
      vrm.update(delta)
      // vrm.blendShapeProxy.update()
    },
    // Custom blend shape
    registerCustomExpression (vrm) {
      const customExpression = vrm.expressionManager.customExpressionMap
      Object.keys(customExpression).forEach((k) => {
        // vrm0.xのVroid製の「驚き」はsurprisedではなくSurprisedとしてCustomExpressionで登録されている
        if (customExpression[k].expressionName === 'Surprised') {
          customExpression[k].expressionName = 'surprised'
          // console.log('new expression', customExpression[k])
        }
        vrm.expressionManager.registerExpression(customExpression[k])
      })
    },
    // addUnkownBlendshapeToVRM (vrm) {
    //   // VRM1.0はすでにSurprisedとか追加されているっぽい
    //   // gltf.userData.gltfExtensions.VRM.blendShapeMaster.blendShapeGroups

    //   // Surprisedなどのの表情を追加
    //   const unkownBlendShapeGroups = vrm.blendShapeProxy.unknownGroupNames
    //   for (let i=0; i < unkownBlendShapeGroups.length; i++) {
    //     const unknownBlendShapeGroup = vrm.blendShapeProxy
    //       .getBlendShapeGroup(unkownBlendShapeGroups[i])
    //     vrm.blendShapeProxy.registerBlendShapeGroup(
    //       unkownBlendShapeGroups[i],
    //       unkownBlendShapeGroups[i],
    //       unknownBlendShapeGroup)
    //     console.log('unknownBlendShapeGroup:', unknownBlendShapeGroup)
    //   }
    // },
    // Outline
    setOutlineToVRM ({ vrm, materials, delta, outlineWidth, color }) {      
      for (let i=0; i<materials.length; i++) {
        const mat = materials[i]
        if (mat.isMToonMaterial) {
          // if (mat.name.includes('Outline')) {
          if (mat.isOutline) {
            mat.uniformsNeedUpdate
            // mat.outlineWidthMode = 'screenCoordinates'
            mat.outlineColorFactor.set(color.r, color.g, color.b, color.a)
            // mat.shouldApplyUniforms = true
            // mat.outlineColor.set(color.r, color.g, color.b, color.a)

            // if (mat.name.includes('CLOTH')) {
            //   mat.outlineWidthFactor = outlineWidth.cloth
            // } else if (mat.name.includes('HAIR')) {
            //   mat.outlineWidthFactor = outlineWidth.hair
            // } else if (mat.name.includes('SKIN')) {
            //   mat.outlineWidthFactor = outlineWidth.skin
            // }

            // 髪のアウトラインは少し細めの方が好み
            if (mat.name.includes('HAIR') || mat.name.includes('hair')) {
              mat.outlineWidthFactor = outlineWidth
              // mat.outlineWidthFactor = (outlineWidth - 0.0005 > 0) ?
              //   (outlineWidth - 0.0005) : outlineWidth
            } else {
              mat.outlineWidthFactor = outlineWidth
            }
          }
        }
      }
      vrm.update(delta)
    },
    // vrmの発光の調整がうまくいかない。。。
    setEmissiveToVRM ({ vrm, materials, delta, emissive }) {
      for (let i=0; i<materials.length; i++) {
        const mat = materials[i]
        if (mat.isMToonMaterial) {
          mat.needsUpdate = true
          mat.uniformsNeedUpdate = true
          // mat.setValue({ emissiveIntensity: emissive.intensity })
          // mat.emissiveIntensity = emissive.intensity
          // mat.emissive.set(1, 1, 1)
          // mat.emissive = 0x999999

          // mat.rimLightingMixFactor = 1.0
          // mat.shadeColorFactor.set(0, 0, 0)
          // mat.outlineWidthFactor = 0.1
          mat.update(delta)
        }
      }
      vrm.update(delta)
    },
    // Custom Texture
    async addCustomTextureToVRM ({ vrm, delta, addingTextureName }) {
      const addingTexture = this.allCustomTextures.filter(tex => tex.name === addingTextureName)[0]
      if (!addingTexture) {
        console.error('No texture:', addingTextureName)
        return
      }
      let targetLayers, matNames
      if (addingTexture.type === 'face-skin') {
        targetLayers = this.faceSkins
          .filter(f => f.uuid === vrm.scene.uuid)[0]
        matNames = ['Face', 'SKIN'] // N00_000_00_Face_00_SKIN
      }
      if (addingTexture.type === 'eye-iris') {
        targetLayers = this.eyeIrises
          .filter(f => f.uuid === vrm.scene.uuid)[0]
        matNames = ['EyeIris', 'EYE'] // N00_000_00_EyeIris_00_EYE
        // 目のテクスチャを貼る時は目の光を隠す
        this.hideSpecificTexture({ vrm, delta, matNames: ['EyeHighlight', 'EYE'] })
      }

      if (!targetLayers) {
        const originalMaterials = vrm.materials
          .filter(mat => {
            const matchingMatNames = matNames.filter(mn => mat.name.includes(mn))
            return matchingMatNames.length === matNames.length && !mat.name.includes('Outline')
          })
        const originalLayers = originalMaterials.map(mat => {
          return { name: 'original', image: mat.map.image }
        })
        targetLayers = {
          uuid: vrm.scene.uuid,
          layers: [ ...originalLayers ], // arguments of drawImage
          originalLayers
        }
        if (addingTexture.type === 'face-skin') {
          this.faceSkins.push(targetLayers)
        }
        if (addingTexture.type === 'eye-iris') {
          this.eyeIrises.push(targetLayers)
        }
      }

      // すでに追加されていたら処理しない
      const existingLayer = targetLayers.layers.filter(l => l.name === addingTextureName)[0]
      if (existingLayer) return
      
      const newCanvasForTexture = this.updateVRMTexture({
        vrm,
        matNames,
        textureLayers: targetLayers,
        addingTextureName,
        delta
      })
      return newCanvasForTexture
    },
    async removeCustomTextureFromVRM ({ vrm, delta, removingTextureName }) {
      const removingTexture = this.allCustomTextures.filter(tex => tex.name === removingTextureName)[0]
      if (!removingTexture) {
        console.error('No texture:', removingTextureName)
        return
      }

      let targetLayers, matNames
      if (removingTexture.type === 'face-skin') {
        targetLayers = this.faceSkins
          .filter(f => f.uuid === vrm.scene.uuid)[0]
        matNames = ['Face', 'SKIN'] // N00_000_00_Face_00_SKIN
      }
      if (removingTexture.type === 'eye-iris') {
        targetLayers = this.eyeIrises
          .filter(f => f.uuid === vrm.scene.uuid)[0]
        matNames = ['EyeIris', 'EYE'] // N00_000_00_EyeIris_00_EYE, N00_000_00_EyeHighlight_00_EYE
      }
      if (!targetLayers) {
        console.error('No removing texture:', removingTextureName)
      }

      targetLayers.layers = targetLayers.layers.filter(fsl => {
        return fsl.name !== removingTextureName
      })

      if (removingTexture.type === 'eye-iris') {
        // 目のテクスチャが初期状態になる時は目の光を元に戻す
        const originalTextures = targetLayers.layers.filter(l => l.name === 'original')
        if (originalTextures.length === targetLayers.layers.length) {
          this.showSpecificTexture({ vrm, delta, matNames: ['EyeHighlight', 'EYE'] })
        }
      }

      const newCanvasForTexture = this.updateVRMTexture({
        vrm,
        matNames,
        textureLayers: targetLayers,
        delta
      })
      return newCanvasForTexture
    },
    async updateVRMTexture ({ vrm, matNames, textureLayers, delta, addingTextureName }) {
      let newCanvasForTexture
      for (let i=0; i<vrm.materials.length; i++) {
        const mat = vrm.materials[i]
        const matchingMatNames = matNames.filter(mn => mat.name.includes(mn))
        if (matchingMatNames.length === matNames.length && !mat.name.includes('Outline')) {
        // if (mat.name.includes('Face_00_SKIN')) {
          const ctx = document.createElement('canvas').getContext('2d')
          ctx.canvas.width = mat.map.image.width
          ctx.canvas.height = mat.map.image.height
          for (let li=0; li < textureLayers.layers.length; li++) {
            const img = textureLayers.layers[li].image
            // ctx.drawImage(img, 0, 0)

            // テクスチャを回転
            ctx.save()
            ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2)
            const TO_RADIANS = Math.PI/180
            ctx.rotate(180 * TO_RADIANS)
            ctx.drawImage(img, -img.width/2, -img.height/2)
            ctx.restore()
          }

          // 追加するテクスチャがある場合
          const textureToAdd = this.allCustomTextures
            .filter(t => t.name === addingTextureName)[0]
          if (textureToAdd) {
            const newLayerImg = await this.loadImage(textureToAdd.path, 'Anonymous')
            textureLayers.layers.push({
              name: addingTextureName, image: newLayerImg 
            })
            // ctx.drawImage(newLayerImg, 0, 0)
            // テクスチャを回転
            ctx.save()
            ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2)
            const TO_RADIANS = Math.PI/180
            ctx.rotate(180 * TO_RADIANS)
            ctx.drawImage(newLayerImg, -(newLayerImg.width/2), -(newLayerImg.height/2))
            ctx.restore()
          }
          newCanvasForTexture = ctx.canvas
          mat.map = new THREE.CanvasTexture(newCanvasForTexture)
          mat.shouldApplyUniforms = true

          // const base64 = ctx.canvas.toDataURL('image/png')
          // console.log('base64:', base64)
        }
      }
      vrm.update(delta)

      return newCanvasForTexture
    },
    showSpecificTexture ({ vrm, delta, matNames }) {
      for (let i=0; i<vrm.materials.length; i++) {
        const mat = vrm.materials[i]
        // N00_000_00_EyeHighlight_00_EYE
        const matchingMatNames = matNames.filter(mn => mat.name.includes(mn))
        // if (mat.name.includes('EyeHighlight') && mat.name.includes('EYE')) {
        if (matchingMatNames.length === matNames.length) {
          mat.visible = true
          mat.shouldApplyUniforms = true
        }
      }
      vrm.update(delta)
    },
    hideSpecificTexture ({ vrm, delta, matNames }) {
      for (let i=0; i<vrm.materials.length; i++) {
        const mat = vrm.materials[i]
        // N00_000_00_EyeHighlight_00_EYE
        const matchingMatNames = matNames.filter(mn => mat.name.includes(mn))
        
        // if (mat.name.includes('EyeHighlight') && mat.name.includes('EYE')) {
        if (matchingMatNames.length === matNames.length) {
          mat.visible = false
          mat.shouldApplyUniforms = true
        }
      }
      vrm.update(delta)
    },
    // Hide eyes
    async hideEyes ({ vrm, delta }) {
      // vrm.scene.traverse(node => {
      //   // console.log('node.name:', node.name)
      //   // console.log(node.type + ':::', node.name)
      //   if (this.facebakedsInSkinnedMeshToToggleEyes.includes(node.name)) {
      //     node.visible = false
      //   }
      // })
      // 目に関連するマテリアルを全て非表示にする
      for (let i=0; i<vrm.materials.length; i++) {
        const mat = vrm.materials[i]
        // console.log(mat.name)
        let doToggle = false
        this.materialNamesToToggleEyes.map(name => {
          if (vrm.materials[i].name.includes(name)) doToggle = true
        })
        if (doToggle) mat.visible = false
      }

      for (let i=0; i<vrm.materials.length; i++) {
        const mat = vrm.materials[i]
        const ctx = document.createElement('canvas').getContext('2d')
        ctx.canvas.width = mat.map.image.width
        ctx.canvas.height = mat.map.image.height
        // console.log('mat.name:', mat.name)
        if (mat.name.includes('EyeWhite')) {
          // console.log('mat.name:', mat.name)
          const newLayerImg = await this.loadImage(this.whiteEyeTexture, 'Anonymous')
          // テクスチャを回転
          ctx.save()
          ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2)
          const TO_RADIANS = Math.PI/180
          ctx.rotate(180 * TO_RADIANS)
          ctx.drawImage(newLayerImg, -(newLayerImg.width/2), -(newLayerImg.height/2))
          ctx.restore()

          const originalTexture = new THREE.Texture()
          this.originalWhiteEyesTextures.push({
            texture: originalTexture.copy(mat.map),
            vrmUuid: vrm.scene.uuid
          })
          const newCanvasForTexture = ctx.canvas
          mat.map = new THREE.CanvasTexture(newCanvasForTexture)
          mat.shouldApplyUniforms = true
          // console.log('hide eyes')
        }
      }
      vrm.update(delta)
    },
    showEyes ({ vrm, delta }) {
      // vrm.scene.traverse(node => {
      //   if (this.facebakedsInSkinnedMeshToToggleEyes.includes(node.name)) {
      //     node.visible = true
      //   }
      // })
      // 目に関連するマテリアルを全て表示する
      for (let i=0; i<vrm.materials.length; i++) {
        const mat = vrm.materials[i]
        let doToggle = false
        this.materialNamesToToggleEyes.map(name => {
          if (vrm.materials[i].name.includes(name)) doToggle = true
        })
        if (doToggle) mat.visible = true
      }

      for (let i=0; i<vrm.materials.length; i++) {
        const mat = vrm.materials[i]
        const ctx = document.createElement('canvas').getContext('2d')
        ctx.canvas.width = mat.map.image.width
        ctx.canvas.height = mat.map.image.height
        if (mat.name.includes('EyeWhite')) {
          const originalTexture = this.originalWhiteEyesTextures
            .filter(t => t.vrmUuid === vrm.scene.uuid)[0]
          if (originalTexture) {
            mat.map = originalTexture.texture
            mat.map.needsUpdate = true
            mat.shouldApplyUniforms = true
            // console.log('show eyes')
          }
        }
      }
      vrm.update(delta)
    },
    // Hair Wind
    updateHairWind ({ vrm, delta, params }) {
      vrm.springBoneManager.joints.forEach(joint => {  	
        joint.settings.gravityPower = params.windForce

        let vec = params.vec
        // // x:^ y:  z: <->
        vec.applyEuler(params.euler)

        const gravity = new THREE.Vector3(0, -1, 0)
        gravity.add(vec)
        joint.settings.gravityDir = gravity.normalize()
     })
     vrm.update(delta)
    },
    resetHairWind ({ vrm, delta }) {
      vrm.springBoneManager.joints.forEach(joint => {
        joint.settings.gravityPower = 0.0
        const defaultGravity = new THREE.Vector3(0, -1, 0)
        joint.settings.gravityDir = defaultGravity.normalize()
      })
      vrm.update(delta)
    }
  }
}